import { ReportsBusinessArea } from '../types/contentful/Pages/ReportsPageContent';
import { ChapteredSubPageBusinessAreaSlug } from '../types/contentful/Pages/ChapteredSubPageContent';
import { ArticleBusinessArea } from '../types/contentful/Pages/SectionedArticleContent';

export const getAppPath = () => process.env.NEXT_PUBLIC_APP_PATH ?? '';
export const getPublicPathUrl = (path: string) => `${getAppPath()}${path}`;

const CANONICAL_URL = process.env.NEXT_PUBLIC_CANONICAL_URL ?? '';

export const getCanonicalUrl = (path: string = '') => `${CANONICAL_URL}${path}`;

export const getCanonicalUrlWithAppPath = (path: string = '') =>
  `${CANONICAL_URL}${getAppPath()}${path}`;

export const getIndexUrl = () => `/`;

export const getAboutUsUrl = () => `https://www.hurtigruten.com/en/corporate`;
export const getOurBrandsUrl = () => `${getAboutUsUrl()}/brands`;
export const getHistoryUrl = () => `${getAboutUsUrl()}/history`;
export const getManagementTeamUrl = () => `${getAboutUsUrl()}/management`;
export const getEmployeeBioUrl = (slug: string) =>
  `${getAboutUsUrl()}/employees/${slug}`;
export const getNewsUrl = () => `${getAboutUsUrl()}/news`;

export const getPeopleUrl = () => `https://www.hurtigruten.com/en/careers`;

export const getDEIUrl = () => `/diversity`;
export const getDEIStatementUrl = () => `${getDEIUrl()}/statement`;
export const getDEIPolicyUrl = () => `${getDEIUrl()}/policy`;
export const getDEICommitmentUrl = () => `${getDEIUrl()}/commitment`;
export const getDEIBrachesUrl = () => `${getDEIUrl()}/breaches`;

export const getSustainabilityUrl = () =>
  `https://www.hurtigruten.com/en/about-us/sustainability`;
export const getSustainabilityNewsUrl = () => `${getSustainabilityUrl()}/news`;
export const getSustainabilityEnvironmentUrl = () =>
  `${getSustainabilityUrl()}/environment`;
export const getSustainabilitySocialUrl = () =>
  `${getSustainabilityUrl()}/social`;
export const getSustainabilityGovernanceUrl = () =>
  `${getSustainabilityUrl()}/governance`;
export const getSustainabilityReportsUrl = () =>
  `${getSustainabilityUrl()}/reports`;
export const getSustainabilityReportListUrl = (slug: string) =>
  `${getSustainabilityReportsUrl()}/${slug}`;
export const getSustainabilityDigitalReportUrl = (slug: string) =>
  `${getSustainabilityReportsUrl()}/esg/${slug}`;

export const getPressAndMediaUrl = () => `https://press.hurtigruten.com/`;

export const getInvestorsUrl = () => `/investors`;
export const getFinancialNewsUrl = () => `${getInvestorsUrl()}/news`;
export const getFinancialAnnouncementsUrl = () =>
  `${getInvestorsUrl()}/announcements`;
export const getFinancialAnnouncementUrl = (articleId: string) =>
  `${getFinancialAnnouncementsUrl()}/${articleId}`;
export const getInvestorsReportUrl = () => `${getInvestorsUrl()}/reports`;
export const getInvestorsReportListUrl = (slug: string) =>
  `${getInvestorsReportUrl()}/${slug}`;
export const getCorporateGovernanceUrl = () =>
  `${getInvestorsUrl()}/governance`;
export const getCorporateGovernancePolicyUrl = (slug: string) =>
  `${getCorporateGovernanceUrl()}/${slug}`;

export const getFoundationUrl = () =>
  `https://www.hurtigruten.com/en/hurtigruten-foundation`;
export const getFoundationApplicationUrl = () =>
  `${getFoundationUrl()}/application`;
export const getFoundationDonationUrl = () => `${getFoundationUrl()}/donation`;
export const getFoundationProjectsUrl = () => `${getFoundationUrl()}/projects`;
export const getFoundationProjectUrl = (slug: string) =>
  `${getFoundationProjectsUrl()}/${slug}`;

export const getApiUrl = () => `${getAppPath()}/api`;
export const getApiIntegrationSwedbankDonateUrl = () =>
  `${getApiUrl()}/integrations/swedbank/donate`;
export const getApiIntegrationSwedbankCallbackUrl = () =>
  `${getApiUrl()}/integrations/swedbank/callback`;

const BUSINESS_AREA_SLUGS: Record<ArticleBusinessArea, string> = {
  'About Us': getAboutUsUrl(),
  DEI: getDEIUrl(),
  'Hurigruten Foundation': getFoundationUrl(),
  'Investor Relations': getInvestorsUrl(),
  'People and Culture': getPeopleUrl(),
  'Press and Media': getPressAndMediaUrl(),
  Sustainability: getSustainabilityUrl(),
};

export const getSectionedArticleUrl = (
  businessArea: ArticleBusinessArea,
  slug: string
) => `${BUSINESS_AREA_SLUGS[businessArea]}/articles/${slug}`;

export const getChapteredSubPageUrl = (
  businessAreaSlug: ChapteredSubPageBusinessAreaSlug,
  slug: string
) => `/${businessAreaSlug}/${slug}`;

const REPORTS_BUSINESS_AREA_SLUGS: Record<ReportsBusinessArea, string> = {
  'Investor Relations': getInvestorsUrl(),
  Sustainability: getSustainabilityUrl(),
};

export const getReportsListUrl = (
  businessArea: ReportsBusinessArea,
  slug: string
) => `${REPORTS_BUSINESS_AREA_SLUGS[businessArea]}/reports/${slug}`;
